import React from 'react';

function LogoPng() {
  return (
    <img src={'./NCSSHlogo.png'} width={110} alt={'logo'} style={{float:'right'}}/>
  );
}

export default LogoPng;